import { render, staticRenderFns } from "./TerraIndigena.vue?vue&type=template&id=d8212ba0&lang=pug"
import script from "./TerraIndigena.vue?vue&type=script&lang=js"
export * from "./TerraIndigena.vue?vue&type=script&lang=js"
import style0 from "./TerraIndigena.vue?vue&type=style&index=0&id=d8212ba0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports